'use client';
import ToastProvider from '@/components/molecules/toastProvider';
import { staticData } from '@/statics/static';
import { Providers } from '@/stores/common/providers';
import { DataProvider } from '@/stores/context';
import { SessionProvider } from 'next-auth/react';

export const metadata = {
  title: 'Vietstats.vn',
  description: staticData.description,
};

export default function ProviderApp({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SessionProvider>
      <Providers>
        <ToastProvider>
          <DataProvider>{children}</DataProvider>
        </ToastProvider>
      </Providers>
    </SessionProvider>
  );
}
